// analytics.ts
import ReactGA4 from 'react-ga4'

ReactGA4.initialize('G-07X6BDPEFR')

export default ReactGA4
